// extracted by mini-css-extract-plugin
export default {"changelogs-container":"ChangeLogs_changelogs-container__nLz7s"};